var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',[_c('Row',[_vm._v(" "+_vm._s(_vm.item.title)+" "),(_vm.isUpgradeRequired)?_c('div',{staticClass:"pl-2"},[_c(_vm.indicator,{tag:"component",attrs:{"billingFeatureId":_vm.item.billingFeatureId}})],1):_vm._e()]),_c('div',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.item.subTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }